import React from 'react';
import { MainLayout } from './components/Layout/MainLayout';
import { ModuleProvider } from './contexts/ModuleContext';
import { EditorProvider } from './contexts/EditorContext';
import { ComponentRegistryProvider } from './contexts/ComponentRegistryContext';
import { VerticalNavProvider } from './contexts/VerticalNavContext';
import { ApiProvider } from './contexts/ApiContext';
import { UIModelApiProvider } from './contexts/UIModelApiContext';
import {TParty} from "../../../../types/Context/AppContext";

type UIModelsModuleProps = {
    projectId: string;
    userId: string;
    userProjectDataModels: any;
    channelId: string;
    industryId?: string;
    selectedParty: TParty;
}

export const UIModelsModule = ({ projectId, userId, userProjectDataModels, channelId, industryId = '', selectedParty}: UIModelsModuleProps) => {
    return (
        <ApiProvider>
            <ModuleProvider industryId={industryId} userId={userId}>
                <ComponentRegistryProvider >
                    <EditorProvider>
                        <UIModelApiProvider configureId={projectId} channelId={channelId}>
                            <VerticalNavProvider>
                                <MainLayout
                                    projectId={projectId}
                                    userProjectDataModels={userProjectDataModels}
                                    selectedParty={selectedParty}
                                />
                            </VerticalNavProvider>
                        </UIModelApiProvider>
                    </EditorProvider>
                </ComponentRegistryProvider>
            </ModuleProvider>
        </ApiProvider>
    );
};

export default UIModelsModule;